import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { CompanyLevelFeatureFlag } from '@mm/state/model/CompanyModel';
import liveChatIcon from 'assets/sidebar-icons/live-chat.svg';
import { ITEMS } from '../../common/constants/items';

export type SidebarMenuDefinition = {
  id: string;
  name: string;
  url: string;
  childRoutes?: string[];
  mustBeSysAdmin: boolean;
  hideForFBCollaborators?: boolean;
  featureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
  hideFeatureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
};

export type SidebarTitleDefinition = {
  id: string;
  text: string;
  icon?: string;
  menuItems: SidebarMenuDefinition[];
  url?: string;
  hideOnMobile: boolean;
  featureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
  hideFeatureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
};

export const SidebarMenuChatStartersMenuItem = {
  id: 'CHAT STARTERS',
  name: 'Chat Starters',
  url: '/chat-starters',
  mustBeSysAdmin: false,
};

export const ChatBotSidebarTitle = {
  id: 'CHATBOT',
  text: 'Chatbot',
  url: '/chat-starters',
  hideFeatureFlag: 'automations' as CompanyLevelFeatureFlag,
  menuItems: [
    SidebarMenuChatStartersMenuItem,
    {
      id: ITEMS.PAGES,
      name: ITEMS.PAGES,
      url: '/build',
      mustBeSysAdmin: false,
    },
    {
      id: ITEMS.QA,
      name: ITEMS.QA,
      url: '/trigger',
      mustBeSysAdmin: false,
    },
    {
      id: ITEMS.AUTOMATION_RULES,
      name: ITEMS.AUTOMATION_RULES,
      url: '/automation-rules',
      mustBeSysAdmin: false,
    },
  ],
  hideOnMobile: false,
};

export const CampaignsMenuTitle = {
  id: 'CAMPAIGNS',
  text: 'Campaigns',
  url: '/campaigns',
  hideFeatureFlag: 'automations' as CompanyLevelFeatureFlag,
  menuItems: [],
  hideOnMobile: false,
};

export const SIDEBAR_MENU: SidebarTitleDefinition[] = [
  ChatBotSidebarTitle,
  {
    id: 'AUTOMATIONS',
    text: 'My Automations',
    url: '/automations',
    hideOnMobile: false,
    menuItems: [],
    featureFlag: 'automations' as CompanyLevelFeatureFlag,
  },
  {
    id: 'INBOX',
    text: 'Inbox',
    icon: liveChatIcon,
    url: '/live-chat',
    hideOnMobile: false,
    menuItems: [],
  },
  CampaignsMenuTitle,
  {
    id: 'LEADS-CONTACTS',
    text: 'Leads',
    url: '/leads-contacts',
    menuItems: [],
    hideOnMobile: false,
  },
  {
    id: 'ANALYTICS',
    text: 'Analytics',
    url: '/bot-analytics',
    menuItems: [
      {
        id: 'BOT_ANALYTICS',
        name: 'Bot Analytics',
        url: '/bot-analytics',
        mustBeSysAdmin: false,
      },
      {
        id: 'CONVERSATION_ANALYTICS',
        name: 'Conversation Analytics',
        url: '/conversation-analytics',
        mustBeSysAdmin: false,
        featureFlag: 'analyticsConversations',
      },
      {
        id: 'ADS_ANALYTICS',
        name: 'Ads Analytics',
        url: '/ads-analytics',
        featureFlag: 'analyticsAds',
        mustBeSysAdmin: false,
      },
      {
        id: 'EMAIL_ANALYTICS',
        name: 'Outreach Analytics',
        url: '/outreach_analytics',
        featureFlag: 'analytics',
        mustBeSysAdmin: false,
      },
    ],
    hideOnMobile: false,
  },
  {
    id: 'INTEGRATIONS',
    text: 'Integrations',
    url: '/integrations',
    menuItems: [],
    hideOnMobile: false,
  },
];
